<script lang="ts" setup>
withDefaults(
  defineProps<{
    isOpen?: boolean
  }>(),
  { isOpen: false }
)
</script>

<template>
  <button class="burger -mr-2 flex size-6 flex-col items-center justify-center md:hidden">
    <span
      class="block h-px w-[21px] bg-black transition-transform duration-300"
      :class="{ 'translate-y-1.5 rotate-45': isOpen }"
    />

    <span
      class="my-1 block h-px w-[21px] bg-black transition-opacity duration-300"
      :class="{ 'opacity-0': isOpen }"
    />

    <span
      class="block h-px w-[21px] bg-black transition-transform duration-300"
      :class="{ '-translate-y-1 -rotate-45': isOpen }"
    />
  </button>
</template>
